import { z } from 'zod';

export const validationFailureExplanationSchema = z.object({
  failureExplanation: z.string().trim().min(1).max(240).optional(),
});

export type ValidationFailureExplanation = z.infer<
  typeof validationFailureExplanationSchema
>;
